// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"e27b7011","787":"c52b7833"}[chunkId] + ".chunk.js";
};